import { render, staticRenderFns } from "./SP.vue?vue&type=template&id=9409a7d6&scoped=true"
import script from "./SP.vue?vue&type=script&lang=ts"
export * from "./SP.vue?vue&type=script&lang=ts"
import style0 from "./SP.vue?vue&type=style&index=0&id=9409a7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9409a7d6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BtnLink: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/btn-link.vue').default})
